import { t } from 'i18next';
import { TbDotsVertical } from "react-icons/tb";
import styles from './EmployerPortalJobs.module.css';

export const actionsUI = (
    index,
    jobId,
    selectedJobs,
    handleJobSelect,
    handleDropdownClose,
    isDropdownEnabled,
    handleToggleDropdown,
    handleJobSelectForDetail
) => {
    const isSelected = selectedJobs?.findIndex((e) => e == jobId)
    return (
        <div
            onClick={() => handleDropdownClose()}>
            <TbDotsVertical style={{ cursor: "pointer" }}
                onClick={(e) => {
                    if (isDropdownEnabled === index + 1) {
                        handleDropdownClose()
                    } else {
                        e.stopPropagation();
                        handleToggleDropdown(index + 1);
                    }
                }}
            />
            {isDropdownEnabled === index + 1 && (
                <div className={`${styles.dropdown} `}>
                    <p
                        className={styles.dropdownItem}
                        onClick={() => {
                            handleJobSelectForDetail(jobId, true);
                        }}
                        style={{ cursor: "pointer" }}
                    >{t('dropdownOptions.viewJob')}</p>
                    <p
                        className={styles.dropdownItem}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            handleDropdownClose();
                            handleJobSelect(jobId);
                        }}
                    >
                        {isSelected !== -1 ? "Unselect" : t('dropdownOptions.select')}
                    </p>
                </div>
            )}
        </div>
    );
};